/** 
 * PERFORMANCE OPTIMIZED: Direct canvas drawing instead of blob conversion
 * Old method: canvas -> blob -> URL -> Image -> draw (13x sequential = SLOW)
 * New method: canvas -> draw directly (13x parallel = FAST)
 */
export const generateLayer = (
    canvasLayer: React.RefObject<HTMLCanvasElement>,
    exportCtx: CanvasRenderingContext2D | null | undefined,
    delayQueue: number = 0,
) => {
    return new Promise<{ status: 'success' } | { status: 'error', data: any }>(resolve => {
        // Skip setTimeout delay for better performance
        if (!canvasLayer.current || !exportCtx) {
            resolve({ status: 'error', data: new Error('No export canvas') });
        } else {
            try {
                // Direct draw - much faster than blob conversion
                exportCtx.drawImage(canvasLayer.current, 0, 0);
                resolve({ status: 'success' });
            } catch (e) {
                console.error('generateLayer', canvasLayer.current.id, e);
                resolve({ status: 'error', data: e });
            }
        }
    });
};